import { render, staticRenderFns } from "./RptSalesJournal.vue?vue&type=template&id=7640881c&"
import script from "./RptSalesJournal.vue?vue&type=script&lang=ts&"
export * from "./RptSalesJournal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports